import validator from 'validator';

export const newsletterSignup =() => {
    const newsletterModules = document.querySelectorAll('.m__newsletter');

    if ( newsletterModules ) {        
        newsletterModules.forEach(mod => {
            const newsletterSignupForm = mod.querySelector('.js__newsletter__form');

            if ( newsletterSignupForm ) {
                newsletterSignupForm.addEventListener('submit', (e) => {
                    e.preventDefault();

                    newsletterSignupForm.classList.add('submitting');

                    setTimeout(() => {
                        newsletterSignupForm.classList.add('hidden');
                    }, 400);

                    grecaptcha.ready(function() {
                        grecaptcha.execute(igniteRecaptchaKey, {action: 'newsletterSignup'}).then(function(token) {

                            let formData = new FormData(newsletterSignupForm);
                            let isFormValid = true;

                            //Reset any errors
                            for (var [key, value] of formData.entries()) {
                                if (key != 'locations' && key != 'events') {
                                    let inputToCheck = document.querySelector('#' + key);
                                    if (inputToCheck.required) {
                                        inputToCheck.classList.remove('error');
                                    }
                                }
                            }

                            //Check for any required fields left blank
                            for (var [key, value] of formData.entries()) {
                                let inputToCheck = document.querySelector('#' + key);
                                
                                if (!value || value == '' || value == '#') {
                                    if (inputToCheck.required) {
                                        isFormValid = false;
                                        inputToCheck.classList.add('error');

                                        if(key == 'BrandID'){
                                            alert('Please select a location');
                                        }
                                    }
                                }else{
                                    if(inputToCheck.type == 'email'){
                                        if(!validator.isEmail(value)){
                                            isFormValid = false;
                                            inputToCheck.classList.add('error');
                                        }
                                    }else if(inputToCheck.type == 'text'){
                                        if(!validator.isAlphanumeric(value)){
                                            isFormValid = false;
                                            inputToCheck.classList.add('error');
                                        }
                                    }
                                }
                            }

                            //Pass through the recaptcha token
                            formData.append('recaptcha',token);

                            if (isFormValid) {
                                fetch(igniteAjax.ajaxurl, {
                                    method: 'POST',
                                    body: formData,
                                })
                                    .then((response) => response.json())
                                    .then((data) => {
                                        if (data.ResponseStatus) {
                                            mod.querySelector('.m__newsletter__success').classList.remove('hidden');
                                        } else {
                                            mod.querySelector('.m__newsletter__fail').classList.remove('hidden');
                                        }
                                    })
                                    .catch((error) => {
                                        mod.querySelector('.m__newsletter__fail').classList.remove('hidden');
                                    });
                            }
                        });
                    });
                });
            }
        });
    }


	const newsletterSubmitButton = document.querySelector('.js__signup'),
		newsletterSignupForm = document.querySelector('#newsletter-signup-form'),
		newsletterThankyou = document.querySelector('#js__newsletter-thankyou'),
		newsletterLocationSelect = document.querySelector('#BrandID');
		popup = document.querySelector('.popup#newsletter');
	/* if(newsletterLocationSelect){
		const choicesConfig = {
			itemSelectText: '',
			shouldSort: false,
			searchEnabled: false,
		};		
		newsletterLocationSelectChoices = new Choices(newsletterLocationSelect,choicesConfig);
	} */

	if(newsletterSubmitButton && newsletterSignupForm){

		newsletterSignupForm.addEventListener('submit',(event) => {
			event.preventDefault();

			newsletterSignupForm.classList.add('submitting');

			grecaptcha.ready(function() {
          		grecaptcha.execute(igniteRecaptchaKey, {action: 'newsletterSignupForm'}).then(function(token) {

					let formData = new FormData(newsletterSignupForm);
					let isFormValid = true;

					//Reset any errors
					for (var [key, value] of formData.entries()) {
						// Skip array-style field names (like restaurant[]) and special fields
						if (key != 'locations' && key != 'events' && !key.includes('[]')) {
							let inputToCheck = document.querySelector('#' + key);
							if (inputToCheck && inputToCheck.required) {
								inputToCheck.classList.remove('error');
							}
						}
					}

					//Check for any required fields left blank
					for (var [key, value] of formData.entries()) {
						// Skip array-style field names (like restaurant[]) as they don't have IDs
						if (key.includes('[]')) {
							continue;
						}
						
						let inputToCheck = document.querySelector('#' + key);
						
						if (!value || value == '' || value == '#') {
							if (inputToCheck && inputToCheck.required) {
								isFormValid = false;
								inputToCheck.classList.add('error');

								if(key == 'BrandID'){
									alert('Please select a location');
								}
							}
						}else{
							if (inputToCheck) {
								if(inputToCheck.type == 'email'){
									if(!validator.isEmail(value)){
										isFormValid = false;
										inputToCheck.classList.add('error');
									}
								}else if(inputToCheck.type == 'text'){
									if(!validator.isAlphanumeric(value)){
										isFormValid = false;
										inputToCheck.classList.add('error');
									}
								}
							}
						}
					}

						


					if (isFormValid) {
						// Check if restaurant checkboxes exist and are checked
						const restaurantCheckboxes = newsletterSignupForm.querySelectorAll('input[name="restaurant[]"]:checked');
						const checkedBrandIDs = Array.from(restaurantCheckboxes).map(checkbox => checkbox.value);

						// If checkboxes are checked, use those BrandIDs; otherwise use the default BrandID
						const defaultBrandID = formData.get('BrandID');
						let brandIDsToProcess = checkedBrandIDs.length > 0 
							? checkedBrandIDs 
							: (defaultBrandID ? [defaultBrandID] : []);

						// Fallback to BrandID 79 if no BrandID is available
						if (brandIDsToProcess.length === 0) {
							console.warn('No BrandID available for submission, falling back to BrandID 79');
							brandIDsToProcess = ['79'];
						}

						// Create an array of promises for all the AJAX requests
						// Each request needs its own reCAPTCHA token since tokens are single-use
						const submitPromises = brandIDsToProcess.map(brandID => {
							// Generate a new reCAPTCHA token for each request
							return grecaptcha.execute(igniteRecaptchaKey, {action: 'newsletterSignupForm'}).then(function(recaptchaToken) {
								// Create a new FormData for each request with the specific BrandID
								const requestFormData = new FormData(newsletterSignupForm);
								requestFormData.set('BrandID', brandID);
								requestFormData.set('recaptcha', recaptchaToken);

								return fetch(igniteAjax.ajaxurl, {
									method: 'POST',
									body: requestFormData,
								})
									.then(async (response) => {
										// Try to parse as JSON, fall back to text if it fails
										const contentType = response.headers.get('content-type');
										let data;
										
										if (contentType && contentType.includes('application/json')) {
											data = await response.json();
										} else {
											// Try to parse as JSON, but handle text responses
											const text = await response.text();
											try {
												data = JSON.parse(text);
											} catch (e) {
												// If it's not JSON, treat it as an error message
												data = { ResponseStatus: false, error: text };
											}
										}
										
										return { brandID, success: data.ResponseStatus || false, data };
									})
									.catch((error) => {
										console.error(`Error submitting for BrandID ${brandID}:`, error);
										return { brandID, success: false, error: error.message || error };
									});
							});
						});

						// Wait for all requests to complete
						Promise.all(submitPromises)
							.then((results) => {
								newsletterSignupForm.classList.remove('submitting');
								
								// Check if all requests were successful
								const allSuccessful = results.every(result => result.success);
								
								if (allSuccessful) {
									popup.querySelector('.popup__title').classList.add('hidden');
									newsletterSignupForm.classList.add('hidden');
									newsletterThankyou.classList.remove('hidden');
								} else {
									newsletterSignupForm.classList.remove('hidden');
									newsletterThankyou.classList.add('hidden');
									console.error('Some submissions failed:', results);
								}
							})
							.catch((error) => {
								console.error('Error processing submissions:', error);
								newsletterSignupForm.classList.remove('submitting');
							});
					}
				});
	        });

		})

	}
}